import dayjs from 'dayjs'
import duration from 'dayjs/plugin/duration'

dayjs.extend(duration)

export const convertIntoDisplayCount = ({
  count,
  maxDisplayCount,
}: {
  count: number
  maxDisplayCount: number
}): string => {
  if (count > maxDisplayCount) return `${maxDisplayCount}+`
  return String(count)
}

export const formatCountByThousandUnit = (count: number): string => {
  if (count < 1000) return count.toString()

  const thousandUnit = Math.round(count / 100) / 10
  return `${thousandUnit}천`
}

export function calculateStay(from: string, to: string) {
  const fromDate = dayjs(from)
  const toDate = dayjs(to)

  if (!fromDate.isValid() || !toDate.isValid()) return null

  const diffDays = toDate.diff(fromDate, 'day')

  const nights = diffDays // 몇박
  const days = diffDays + 1 // 몇일

  return diffDays >= 1 ? `${nights}박 ${days}일` : `${days}일`
}
